__webpack_require__.p = "/staking/";